import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToastContainerComponent } from '@app/modules/toasts/components/toast-container/toast-container.component';
import { ToastComponent } from '@app/modules/toasts/components/toast/toast.component';
import { SpinnerComponent } from '@app/standalone-components/spinner/spinner.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    declarations: [
        ToastComponent,
        ToastContainerComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        NgbToastModule,
        SpinnerComponent
    ],
    exports: [
        ToastContainerComponent
    ]
})
export class ToastsModule { }
